import { connect } from 'react-redux';
import BulkJobsList from "./BulkJobsList";
import {getBulkJobsFormattedData, getJobs, loadingBulkJobs} from "../../../reducers/accreditation/bulk";
import {getTranslation} from "../../../reducers/common/localization";
import {getCurrentGroup} from "../../../reducers/account/role";
import {hideModal, MODAL_REMOVE_BULK, showModal} from "../../../reducers/common/activeModal";
import { getKey, getKeyLoading } from '../../../reducers/accreditation/certificate';
import {fetchGetOrg, isAccreditationSigningRequired, loadingOrg} from '../../../reducers/organization/organization';

const mapStateToProps = state => {
    return {
        translation: getTranslation(state),
        loading: loadingBulkJobs(state),
        data: getBulkJobsFormattedData(state),
        group: getCurrentGroup(state),
        signingKey: getKey(state),
        signingKeyLoading: getKeyLoading(state),
        isSigningRequired: isAccreditationSigningRequired(state),
        orgLoading: loadingOrg(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onLoadJobs: () => dispatch(getJobs()),
        onRemoveBulk: () => dispatch(showModal({modalKey: MODAL_REMOVE_BULK})),
        onCancelRemoving: () => dispatch(hideModal()),
        onGetOrganization: () => {
            dispatch(fetchGetOrg());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BulkJobsList);



// WEBPACK FOOTER //
// ./src/components/accreditationManagement/bulkJobsList/BulkJobsList.container.js